import $ from 'jquery';


/* Tabs
********************************************/

if ($('.js-tabs-nav').length) {
	$('.js-tabs-nav a').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var $parent = $this.parent();

		// Get the name of tab content that should be controled
		var tabsName = $parent.closest('.js-tabs-nav').attr('data-tab');

		// Remove selected class from all tab titles and add it to the one just clicked
		$('.js-tabs-nav[data-tab="' + tabsName + '"] li').removeClass('is-selected');
		$parent.addClass('is-selected');

		// Check clicked link href and show matching tab content
		var tabsItem = $this.attr('href');
		$('.c-tabs-content[data-tab="' + tabsName + '"] .c-tabs-item').not(tabsItem).removeClass('is-active');
		$(tabsItem).addClass('is-active');

		const tabs2Name = $parent.closest( '.js-tabs-nav' ).data( 'tab2' );
		if ( tabs2Name ) {
			$( '.js-tabs-nav[data-tab="' + tabs2Name + '"] li' ).removeClass( 'is-selected' );
			var tabs2Item = $this.data( 'href2' );
			$( '.c-tabs-content[data-tab="' + tabs2Name + '"] .c-tabs-item' ).not( tabs2Item ).removeClass( 'is-active' );
			$( tabs2Item ).addClass( 'is-active' );
		}

		$( tabsItem + ' .js-gallery-slider, ' +  tabsItem + ' .js-document-slider' ).slick( 'setPosition' );
	});
}
